<template>
  <printBase ref="LinkQR017" :title='title' :page='page'>
    <div v-for="(printInfo, pageIndex) in printInfoList" :key="pageIndex" :slot="page==1? 'content' : `content${pageIndex+1}`" class="printLinkQR">
      <div class="printTitle">近效期药品催销表</div>
      <div style="float:right">
        <span style="margin-right:60px;">填报日期：</span>
        <span style="margin-right:30px;">年</span>
        <span style="margin-right:30px;">月</span>
        <span>日</span>
      </div>
      <table style="width: 100%" class='printContent' border='1' cellspacing="0">
        <tr>
          <th style="width: 8%;">商品码</th>
          <th style="width: 14%;">品名</th>
          <th style="width: 8%;">规格</th>
          <th style="width: 6%;">库存数量</th>
          <th style="width: 5%;">批号</th>
          <th style="width: 8%;">有效期至</th>
          <th style="width: 10%;">生产厂家</th>
          <th style="width: 13%;">供货单位</th>
          <th style="width: 5%;">单价</th>
          <th style="width: 6%;">总金额</th>
          <th style="width: 6%;">处理意见</th>
        </tr>
        <tbody>
          <tr v-for="(item, printIndex) in printInfo" :key="printIndex">
            <td><span>{{ item.inventoryExpireDrugSerialCode}}</span></td>
            <td><span>{{ item.inventoryExpireApprovedDrugNames}}</span></td>
            <td><span>{{ item.inventoryExpireSpecifications}}</span></td>
            <td><span>{{ item.inventoryExpireGoodsStockAmount}}</span></td>
            <td><span>{{ item.inventoryExpireGoodsBatchNumber}}</span></td>
            <td><span>{{ item.inventoryExpireGoodsExpiryDate}}</span></td>
            <td><span>{{ item.inventoryExpireManufacturer}}</span></td>
            <td><span>{{ item.inventoryExpireSupplierName}}</span></td>
            <td><span>{{ item.price}}</span></td>
            <td><span>{{ item.amount}}</span></td>
            <td><span></span></td>
          </tr>
        </tbody>

      </table>
      <div>
          <span>养护员：</span>
          <span style="margin-left:100px;">质量负责人：</span>
          <span style="margin-left:100px;">采购员：</span>
          <span style="margin-left:100px;">店长：</span>
        </div>
    </div>
  </printBase>
</template>
<script>
import _ from 'lodash';
import printBase from './printBase';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';

export default {
  data() {
    return {
      title: 'Link-QR-017',
      printInfoList: [],
      page: 1,
      pageSize: 15,
    };
  },
  components: {
    printBase,
  },
  methods: {
    handlePrint(inventoryIds) {
      inventory.getAlertPrintData({ inventoryIds }).then((res) => {
        if (res.data.status === 200) {
          console.log(res);
          const resultList = [];
          res.data.data.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.inventoryExpireGoodsExpiryDate = utils.exchangeTime(result.inventoryExpireGoodsExpiryDate);
            resultList.push(result);
          });
          this.printInfoList = _.chunk(resultList, this.pageSize);
          this.page = this.printInfoList.length;
          this.$nextTick(() => {
            this.$refs.LinkQR017.handlePrint();
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.printContent td,th{
    text-align: center;
    position: relative;
    border-color: #000;
    font-weight: 300;
    word-break: break-al l;
    padding: 2px 6px;
    font-size: 12px;
    *{
      display: inline-block;
      height: 38px;
      max-height: 32px;
      overflow:hidden
    }

  }
</style>
